import { ShineBorder } from "@/components/magicui/shine-border";
import { Button } from "@/components/ui/button";

export default function CallToAction() {
  return (
    <section className="py-16">
      <div className="mx-auto max-w-5xl rounded-3xl border px-6 py-12 md:py-20 lg:py-32 bg-card">
        <div className="text-center">
          <h2 className="text-balance text-4xl font-semibold lg:text-5xl">
            Your License is a Download Away.
          </h2>
          <p className="mt-4">
            The Part-66 exams are tough, but your career as a certified Aircraft
            Maintenance Engineer is worth it. Stop feeling unprepared. Don't
            leave your career to chance. Join hundreds of technicians who are
            using Part-66 Pro to pass their exams on the first try. Download the
            app today and start studying for free.
          </p>

          <div className="mt-12 flex flex-wrap justify-center gap-4">
            <Button asChild size="lg">
              <a href="https://apps.apple.com/us/app/part-66-pro-easa-mock-exam/id6751455095">
                <span>Download on the App Store</span>
              </a>
            </Button>
          </div>
        </div>

        <ShineBorder shineColor="dark" />
      </div>
    </section>
  );
}
